import { render, staticRenderFns } from "./OtherUserMessageList.vue?vue&type=template&id=782a5a8a&lang=pug"
import script from "./OtherUserMessageList.vue?vue&type=script&lang=ts"
export * from "./OtherUserMessageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports